import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';
import { useDashboardHomeMobileNavbarScroll } from '../../hooks/useDashboardHomeMobileNavbarScroll';

const BODY_ACTIVE_CLASS = 'dashboard-home-mobile-active';

/**
 * 手机首页专用壳：唯一纵向滚动层 + 顶栏收起逻辑。
 * 避免 main / 内层 flex 争抢滚动导致监听失效。
 */
const DashboardHomeMobileShell = ({ children }) => {
	const [scrollEl, setScrollEl] = useState(null);
	const setScrollRef = useCallback((node) => {
		setScrollEl(node);
	}, []);

	useDashboardHomeMobileNavbarScroll(scrollEl);

	useEffect(() => {
		document.body.classList.add(BODY_ACTIVE_CLASS);
		return () => {
			document.body.classList.remove(BODY_ACTIVE_CLASS);
		};
	}, []);

	return (
		<div ref={setScrollRef} className='dashboard-home-mobile-scroll'>
			{children}
		</div>
	);
};

DashboardHomeMobileShell.propTypes = {
	children: PropTypes.node.isRequired,
};

export default DashboardHomeMobileShell;
